import React from "react";
import Course from "../commonComponents/Course";
import {
  //  Box,
  //  Button,
  Grid,
  Typography,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import cardReactJSImage from "../assets/cardReactJSImage.png";
import cardReactNativeImage from "../assets/cardReactNativeImage.png";
import cardUIImage from "../assets/cardUIImage.png";
import cardQAImage from "../assets/cardQAImage.png";
import cardRubyImage from "../assets/cardRubyImage.png";
const DATA = [
  {
    id: "1",
    img: cardUIImage,
    lesson: "3",
    duration: "2 hours 40 minutes",
    description:
      "Master UI/UX principles to create intuitive and engaging interfaces.",
    rating: ":star:️ :star:️ :star:️ :star:️ :star:️",
    price: "$60.00",
    beginner: true,
  },
  {
    id: "2",
    img: cardReactJSImage,
    lesson: "3",
    duration: "2 hours 40 minutes",
    description:
      "Learn React JS essentials: Building dynamic web apps with hands-on projects.",
    rating: ":star:️ :star:️ :star:️ :star:️ :star:️",
    price: "$60.00",
    width: "100%",
    beginner: true,
    backgroundColor: "#000000",
  },
  {
    id: "3",
    img: cardReactNativeImage,
    lesson: "3",
    duration: "2 hours 40 minutes",
    description: "Master React Native: Code, design, and deploy stunning apps.",
    rating: ":star:️ :star:️ :star:️ :star:️ :star:️",
    price: "$60.00",
    beginner: true,
  },
  {
    id: "4",
    img: cardRubyImage,
    lesson: "3",
    duration: "2 hours 40 minutes",
    description: `Learn Rails essentials: MVC, CRUD, REST, Deployment.`,
    rating: ":star:️ :star:️ :star:️ :star:️ :star:️",
    price: "$60.00",
    beginner: true,
  },
  {
    id: "5",
    img: cardQAImage,
    lesson: "3",
    duration: "2 hours 40 minutes",
    description:
      "Introduction to Software Testing: Techniques, Tools, and Best Practices.",
    rating: ":star:️ :star:️ :star:️ :star:️ :star:️",
    price: "$60.00",
    beginner: true,
  },
  // {
  //   id: "6",
  //   img: cardReactJSImage,
  //   lesson: "3",
  //   duration: "2 hours 40 minutes",
  //   description: "Learn Essentials of User Interface Design in Figma",
  //   rating: ":star:️ :star:️ :star:️ :star:️ :star:️",
  //   price: "$60.00",
  //   beginner: true,
  // },
];
// const skills = [
//   "All",
//   "React JS",
//   "React-Native",
//   "UI/UX Design",
//   "Ruby On Rails",
//   "Quality Assurance",
// ];
export default function Skills() {
  const classes = useStyles();
  // const [showCourses, setShowCourses] = useState(false);
  // const [selectedCourse, setselectedCourse] = useState("All");
  // const showCourse = () => {
  //   setShowCourses(!showCourses);
  // };
  // const selectCourse = (option: any) => {
  //   setselectedCourse(option);
  // };
  return (
    <Grid container className={classes.mainGrid}>
      <Grid
        item
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        className={classes.titleGrid}
      >
        <Typography
          className={classes.title}
          align="center"
          style={{ fontWeight: "700" }}
        >
          Elevate Your Skills in Top Programming Languages with{" "}
          <span className={classes.codezzyText}>Codezzy</span>
        </Typography>
        <Divider className={classes.skillDivision}></Divider>
      </Grid>
      {/* <Grid
        item
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        className={classes.selection}
      >
        <Box className={classes.skills}>
          {skills.map((element, index) => (
            <>
              <Typography
                className={classes.skill}
                style={{ fontWeight: "500" }}
              >
                {element}
              </Typography>
              {index !== 5 && <Divider className={classes.skillsDivision} />}
            </>
          ))}
        </Box>
        <Box
          className={classes.dropDown}
          style={{ fontWeight: "700" }}
          onClick={() => {
            showCourse();
          }}
        >
          {selectedCourse} <KeyboardArrowDownIcon />
        </Box>
        {showCourses && (
          <Box className={classes.dropDownBox}>
            {skills.map((option) => (
              <Typography
                className={classes.options}
                onClick={() => {
                  selectCourse(option);
                }}
              >
                {option}
              </Typography>
            ))}
          </Box>
        )}
      </Grid> */}
      <Grid
        item
        xs={12}
        lg={12}
        md={12}
        sm={12}
        xl={12}
        className={classes.rightSide}
      >
        <Grid container className={classes.cardContainer}>
          {DATA.map((element, index: number) => (
            <Grid
              item
              key={index}
              xs={12}
              sm={12}
              md={4}
              lg={4}
              className={classes.cards}
            >
              <Course data={element} />
            </Grid>
          ))}
          {/* <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={11}
            xl={11}
            className={classes.btnOutside}
          >
            <Box className={classes.viewMoreBtnBox}>
              <Button
                variant="outlined"
                className={classes.viewMoreBtn}
                style={{ fontWeight: "700", textTransform: "none" }}
              >
                View More <KeyboardArrowDownIcon />
              </Button>
            </Box>
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
}
const useStyles = makeStyles((theme) => ({
  mainGrid: {
    padding: "20px !important",
    [theme.breakpoints.down("sm")]: {
      padding: "10px !important",
    },
  },
  "& .MuiCardContent-root": {
    padding: "0px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "10px !important",
    [theme.breakpoints.down("sm")]: {
      margin: "5px !important",
    },
  },
  rightSide: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px !important",
    [theme.breakpoints.down("sm")]: {
      margin: "5px !important",
    },
  },
  cardContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  skillDivision: {
    margin: "10px 10px 15px 10px !important",
    height: "4px !important",
    width: "324px !important",
    background: "rgba(239, 182, 182, 1) !important",
    [theme.breakpoints.down("sm")]: {
      width: "254px !important",
      margin: "10px !important",
    },
  },
  skillsDivision: {
    backgroundColor: "black !important",
    width: "26.78px !important",
    rotate: "-90deg !important",
    height: "1.3px !important",
    borderRadius: "1px !important",
  },
  skillDivision2: {
    margin: "10px 10px 10px 10px !important",
    height: "2px !important",
    width: "60% !important",
    background: "white !important",
    "&:hover": {
      background: "rgba(239, 182, 182, 1) !important",
    },
  },
  title: {
    fontSize: "30px !important",
    fontFamily: "Nunito !important",
    margin: "10px 10px 15px 10px !important",
    fontWeight: 700,
    lineHeight: "40.92px !important",
    maxWidth: "559px !important",
  },
  cards: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px !important",
    [theme.breakpoints.down("sm")]: {
      padding: "0px !important",
    },
  },
  selection: {
    margin: "10px 10px 15px 10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  codezzyText: { color: "rgba(87, 152, 254, 1) !important" },
  skills: {
    display: "flex",
    width: "1077px",
    justifyContent: "space-evenly",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "845px",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  skill: {
    cursor: "pointer !important",
    fontWeight: 500,
    padding: "5px !important",
    lineHeight: "21px !important",
    fontSize: "18px !important",
    fontFamily: "Roboto !important",
    borderBottom: "1px solid white !important",
    "&:hover": {
      borderBottom: "1px solid rgba(242, 39, 126, 1) !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "18px !important",
      padding: "5px 7px 5px 7px !important",
    },
  },
  dropDown: {
    display: "none",
    width: "290px",
    height: "36px",
    cursor: "pointer",
    border: "1px solid rgba(210, 210, 210, 1) !important",
    borderRadius: "3px",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "10px",
      fontWeight: 500,
      fontSize: "16px !important",
      fontFamily: "Nunito !important",
      lineHeight: "21.82px !important",
    },
    [theme.breakpoints.down("xs")]: {
      width: "240px",
    },
  },
  dropDownBox: {
    display: "none",
    width: "290px",
    cursor: "pointer",
    border: "1px solid rgba(210, 210, 210, 1) !important",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "10px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "240px",
    },
  },
  options: {
    fontSize: "16px !important",
    fontFamily: "Nunito !important",
    lineHeight: "21.82px !important",
    fontWeight: 500,
    margin: "2px !important",
    padding: "2px !important",
    cursor: "pointer",
  },
  btnOutside: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  viewMoreBtnBox: {
    minWidth: "900px",
    width: "1570px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  viewMoreBtn: {
    color: "#5798FE !important",
    borderColor: "#5798FE !important",
    fontSize: "16px !important",
    fontWeight: 700,
    lineHeight: "18.75px !important",
    width: "100% !important",
    fontFamily: "Roboto !important",
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none !important",
    },
    height: "80.37px !important",
  },
}));